import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MygalleriesComponent } from './mygalleries.component';

const routes: Routes = [{ path: '', component: MygalleriesComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MygalleriesRoutingModule { }
